import api from './axiosConfig';
import axios from 'axios';
import { storeTokenExpiry, clearTokenExpiry } from '../utils/tokenExpiry';

axios.defaults.withCredentials = true;

const API_URL = 'https://panel.transkyrios.com/api/auth';
const API_URL_PERSONAS = 'https://panel.transkyrios.com/api/personas';

export const login = async (credenciales) => {
  const { data } = await axios.post(`${API_URL}/login`, credenciales);
  if (data?.exp) storeTokenExpiry(data.exp);
  return data;
};

export const refreshToken = async () => {
  const { data } = await axios.post(
    `${API_URL}/refresh-token`, {}, 
    { withCredentials: true }
  );
  if (data?.exp) storeTokenExpiry(data.exp);
  return data;
}

export const logout = async () => {
  try {
    await axios.post(
      `${API_URL}/logout`, {}, 
      { withCredentials: true }
    );
  } finally {
    // Limpia el estado de la sesión en el cliente sin importar si el post tuvo éxisto
    clearTokenExpiry();
    localStorage.removeItem('__lastActiveAt');
    localStorage.removeItem('perfilActivo');

    // Avisa a otras pestañas que tambien cierren sesión
    try { localStorage.setItem('__forceLogout', String(Date.now())); } catch {}
  }
};

export const getPerfil = async () => {
  try {
    const response = await axios.get(`${API_URL}/perfil`, 
      { withCredentials: true }
    );
    if(response.data.ok === false) {
      window.location.href = '/auth/login';
      return null;
    }
    return response.data; 
  } catch (error) {
    if (error.response?.status === 401) {
      window.location.href = '/auth/login';
      return null;
    }
    throw error;
  }
};

export const obtenerPermisosPerfil = async (id_perfil) => {
  const response = await axios.get(`${API_URL}/permisos-perfil/${id_perfil}`, 
    {withCredentials: true}
  );
  return response.data; 
};

export const cambiarContrasena = async (data) => {
  try{
    const response = await api.post(`${API_URL_PERSONAS}/cambiar-contrasena`, data, {
      withCredentials: true
    });

    return response.data;

  } catch (error) {
    throw error.response?.data.msg || error;
  }
}